import { ThemedText } from "@/components/ThemedText";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

interface OrDividerProps {
  labelKey?: string;
}

export function OrDivider({ labelKey = "OR" }: OrDividerProps) {
  const { t } = useTranslation();

  return (
    <View className="flex-row items-center my-5">
      <View className="flex-1 h-px bg-gray-200" />
      <ThemedText className="mx-3 text-sm text-gray-600">
        {t(labelKey)}
      </ThemedText>
      <View className="flex-1 h-px bg-gray-200" />
    </View>
  );
}
